import { Injectable } from '@angular/core';

import { ignoreElementsTyped } from '@frontend/sports/common/core/utils/rxjs';
import { LocalStoreService } from '@frontend/vanilla/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { filter, map, tap } from 'rxjs';

import { selectIsLinearBetslip } from '../../../base/store/selectors';
import { IBetslipRootState } from '../../../base/store/state';
import BetslipPickActions from '../../picks/actions';
import { betslipPicksListCountSelector } from '../../picks/selectors';
import { BetslipTeaserActions } from '../actions';
import { LinearTeaserExpandedLocalStorageKey } from '../models';

@Injectable()
export default class TeaserBetLinearEffects {
    constructor(
        private actions$: Actions,
        private store: Store<IBetslipRootState>,
        private localStorage: LocalStoreService,
    ) {}

    resetTeaserModuleExpanded$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipPickActions.removePick, BetslipPickActions.removeMultiplePicks),
            concatLatestFrom(() => this.store.select(selectIsLinearBetslip)),
            filter(([_, isLinear]) => isLinear),
            concatLatestFrom(() => this.store.select(betslipPicksListCountSelector)),
            filter(([_, picksCount]) => picksCount === 0),
            map(() => BetslipTeaserActions.toggleExpandLinearTeaserBet({ isExpanded: false })),
        );
    });

    handleTeaserBetExpandClicked$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipTeaserActions.clickExpandLinearTeaserBet),
            concatLatestFrom(() => this.store.select(selectIsLinearBetslip)),
            filter(([_, isLinear]) => isLinear),
            map(([action]) => BetslipTeaserActions.toggleExpandLinearTeaserBet({ isExpanded: action.isExpanded })),
        );
    });

    handleTeaserBetExpandToggled$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(BetslipTeaserActions.toggleExpandLinearTeaserBet),
                concatLatestFrom(() => this.store.select(selectIsLinearBetslip)),
                filter(([_, isLinear]) => isLinear),
                tap(([action]) => this.localStorage.set(LinearTeaserExpandedLocalStorageKey, action.isExpanded)),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );
}
